
<ng-container *ngIf="product"
>
    <div class="product-card__image">

        <div class="image">
            <a class="image__body">
                <img class="image__tag" [src]="product.cover_image" alt="" style="height: 180px; width: 100%;">
            </a>
        </div>


    </div>
    <div class="product-card__info">


        <div class="product-card__price product-card__price--current">
            <div>
                <a >{{ product.name }}</a>
            </div>
        </div>
    </div>
    <div class="product-card__footer">
        <div class="product-card__prices">

            <ng-container >
                <div class="product-card__price product-card__price--current">{{product.name}}</div>
            </ng-container>
        </div>
        <ng-container>
            <button
                type="button"
                class="product-card__addtocart-icon"
                (click)="navigate(product.slug)"
            >
            <!-- Read More -->
            <!-- <mat-icon>open_in_new</mat-icon> -->
            View

            </button>



        </ng-container>
    </div>


</ng-container>
